const setPosition = position => parseInt(position, 10) || 999;

export default {
  setPosition,
};
